import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';

import "./AnswerItem.scss";
import { getWordEnding } from "../../../../methods";

class AnswerItem extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
  };

  render() {
    const { item, index } = this.props;

    const bgClass = classnames({
      'item-line': true,
      'line-bg': true,
      'isMax': item.most_popular,
    });

    return (
      <div className="item-main">
        <div className="item-title">{index + 1}. {item.text}</div>
        <div className={bgClass}>
          <div
            className='item-line line-value'
            style={{width: item.percentage + '%'}}
          />
        </div>
        <div className="item-data">
          {item.percentage}%, {item.votes} {getWordEnding(item.votes, ['голос', 'голоса', 'голосов'])}
        </div>
      </div>
    );
  }
}

export default AnswerItem;
